import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";
import ClinvarModal from "../../../../components/ClinvarModal/ClinvarModal";
import Modal from "../../../../../../components/atoms/Modal";
import Btn from "../../../../../../components/atoms/Btn";
import ReviewStars from "../../../../components/ReviewStars";

function ClinvarCNV({ item }) {
  const [clinvarData, setClinvarData] = React.useState(null);

  return (
    <div className="tw-px-1 tw-py-px">
      {item?.regionData?.review_status ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-28">Review Status</div>
          <div className="tw-flex-grow">{item.regionData.review_status}</div>
          <div>
            <Btn
              className="link tw-text-primary"
              onSubmit={() => setClinvarData(item.regionData)}
            >
              [view data]
            </Btn>
          </div>
        </div>
      ) : null}

      {item?.clinicalSig === undefined ? null : (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-28">Cln. Significance</div>
          <div className="tw-flex-grow">{item.clinicalSig}</div>
        </div>
      )}

      {item?.regionData?.review_stars === undefined ? null : (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-28">Review Rating</div>
          <div className="tw-flex-grow">
            <ReviewStars stars={item?.regionData?.review_stars} />
          </div>
        </div>
      )}

      <Modal
        isOpen={Boolean(clinvarData)}
        containerClassName="prevent-tooltip-close"
        className="tw-w-90screen tw-max-w-screen-xl"
        onRequestClose={() => setClinvarData(null)}
        ContentRender={() => (
          <ClinvarModal
            cnv={item}
            clinvarInformation={clinvarData}
            onRequestClose={() => {}}
          />
        )}
      />
    </div>
  );
}

ClinvarCNV.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

ClinvarCNV.defaultProps = {};

export default ClinvarCNV;
